require('./consentProfileSection.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const { bindActionCreators } = require('redux');

// @commons
const { formatText, FormattedText } = require('core/i18n').i18n;
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { OKLink } = require('commonsComponents/OKLink');

// @actions
const consentsActions = require('actions/consentsProfile');

class ConsentProfileSection extends React.Component {
    render() {
        return (
            <OKSectionBox className="consent-profile-section" title={formatText('consentProfile-title')}>
                <div className="row">
                    <div className="col-xs-12 content-no-padding consent-profile-section__description">
                        <FormattedText value="consents-profileSectionDescription" />
                    </div>
                    <div className="col-xs-12 content-no-padding last-cell">
                        <OKLink modifier="complementary" to="/myprofile/consent">
                            <FormattedText value="consentProfile-link" />
                        </OKLink>
                    </div>
                </div>
            </OKSectionBox>
        );
    }
}

ConsentProfileSection.propTypes = {
    consentsActions: PropTypes.func,
    immConsentsProfile: PropTypes.object,
};

ConsentProfileSection.defaultProps = {
    consentsActions: () => { },
    immConsentsProfile: {}
};

module.exports.constructor = ConsentProfileSection;

module.exports.ConsentProfileSection = connect(
    state => ({
        immConsentsProfile: state.consentsProfile,
    }),
    dispatch => ({
        consentsActions: bindActionCreators(consentsActions, dispatch)
    })
)(ConsentProfileSection);
